import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type UploadAnalyticsCommonParams } from './uploadAnalyticsTypes';
import META from './useTrackUploadStarted.meta';

export type UseTrackUploadStartedParams = UploadAnalyticsCommonParams & {
  max_retry_count?: number;
  queued_duration_ms?: number;
  retry_count: number;
  start_reason: 'initial' | 'retry';
  started_after_url_fetch?: boolean;
  upload_url_type?: 'primary' | 'fallback';
};

export const useTrackUploadStarted = () => {
  const { track } = useAnalyticsUtilities();

  const trackUploadStarted = useCallback(
    (params: UseTrackUploadStartedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackUploadStarted };
};
